import { forceLogin } from './force-login.js';
import { logout } from './logout.js';
import { tryLogin } from './try-login.js';
import { type AuthLogin, type AuthLogout } from './types.js';

/**
 * Auth API
 * @interface
 */
export type FabricAuthApi = {
  /**
   * 无论当前未登录/已经登陆都不启动登陆界面, 但是返回已存在的`授权`数据
   */
  tryLogin: AuthLogin;
  /**
   * 如果当前未登录: 则强制启动登陆面板执行完登陆流程, 返回调用端`授权`数据; 如果已登陆, 则直接返回`授权`不启动登陆面板.
   */
  forceLogin: AuthLogin;
  /**
   * 同步接口, 注销用户信息, 注销用户已有的授权信息
   */
  logout: AuthLogout;
};

export const fabricAuth: FabricAuthApi = {
  tryLogin,
  forceLogin,
  logout,
};
